module.exports = __webpack_public_path__ + "img/sign_after.e74dece8.png";